import { render, staticRenderFns } from "./RolesPermissionsMatrix.vue?vue&type=template&id=875825ae"
import script from "./RolesPermissionsMatrix.vue?vue&type=script&lang=js"
export * from "./RolesPermissionsMatrix.vue?vue&type=script&lang=js"
import style0 from "./RolesPermissionsMatrix.vue?vue&type=style&index=0&id=875825ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports